import { render, staticRenderFns } from "./fits-for-lazy.vue?vue&type=template&id=6b2c6e28&"
import script from "./fits-for-lazy.vue?vue&type=script&lang=js&"
export * from "./fits-for-lazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports